module.exports = __webpack_public_path__ + "static/media/inventory-icon.28e5f62c.svg";